module.exports = __webpack_public_path__ + "img/food2.4b267b1a.jpg";